import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import qs from 'qs';

import './VerifyPage.less';

import VerifyPageEN from './locales/VerifyPage_en.json';
import VerifyPageFR from './locales/VerifyPage_fr.json';

class VerifyPage extends React.PureComponent {
  constructor(props) {
    super(props);

    i18next.addResourceBundle('en', 'VerifyPage', VerifyPageEN);
    i18next.addResourceBundle('fr', 'VerifyPage', VerifyPageFR);

    this.resend = this.resend.bind(this);
  }

  componentDidUpdate() {
    let session = this.props.session;
    if (!session.user || session.userTypeId === 1 || session.user.statusId === 1) {
      const queryString = qs.parse(window.location.search);
      // qs v6.9.1 keep the ? for the first query. Updated to 6.9.4. Need a verification to know if it's still needed.
      if (queryString.from || queryString['?from']) {
        let url = queryString.from || queryString['?from'];
        const target = new URL(url, window.location.href);
        if (target.origin === window.location.origin)
          this.props.history.push(url);
      } else {
        this.props.history.push(`/${this.props.locale}`);
      }
    }
  }

  render() {
    const { t } = this.props;

    return (
    <div class="VerificationPage">
      <h1>{t('Vérification nécessaire')}</h1>
		  <div dangerouslySetInnerHTML={{ __html: t('Vous devez vérifier votre compte pour continuer')}} />
      <div>
        <button type="submit" class="ant-btn" onClick={this.resend}>{t('Renvoyer le courriel')}</button>
      </div>
    </div>)
  }

  resend() {
    this.props.sendRegistrationEmail();
  }
}

VerifyPage.defaultProps = {
  banners: null,
  isBillingConfigured: false
};

VerifyPage.propTypes = {
  banners: PropTypes.object
};

export default translate('VerifyPage')(VerifyPage);
